import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/styles';
import { Typography } from '@mui/material';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';

const PrimaryContainedStyledButton = styled(Button)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  color: theme.palette.info.contrastText as string,
  backgroundColor: theme.palette.primary.main,
  'box-shadow': '0 0 #0003, 0 0 #00000024, 0 0 #0000001f !important',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.info.contrastText as string,
  },
}));

const PrimaryOutlinedStyledButton = styled(Button)(({ theme }) => ({
  color: `${theme.palette.secondary}`,
  padding: `${theme.spacing(.5)} ${theme.spacing(1.5)}`,
  margin: theme.spacing(.5),
  borderColor: theme.palette.grey[300],
  '&:hover': {
    borderColor: theme.palette.grey[400],
    backgroundColor:theme.palette.grey[200],
  },}));

const PrimaryLoadingStyledButton = styled(LoadingButton)(
  ({ theme }) => ({
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    color: theme.palette.info.contrastText as string,
    backgroundColor: theme.palette.primary.main,
    'box-shadow': '0 0 #0003, 0 0 #00000024, 0 0 #0000001f !important',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.info.contrastText as string,
    },
  })
);

const GreyOutlinedStyledButton = styled(Button)(({ theme }) => ({
  color: '#000000de',
  padding: `${theme.spacing(0.875)} ${theme.spacing(1.875)}`,
  borderColor: theme.palette.grey[300],
  '&:hover': {
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[200],
  },
  '&:focus': {
    '& .MuiTypography-root': {
      'font-weight': '600 !important',
    },
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[200],
  },
}));

export const GreyOutlinedButton = React.forwardRef<
  HTMLButtonElement,
  ButtonProps
>((props, ref) => {
  return (
    <GreyOutlinedStyledButton
      ref={ref}
      {...props}
      disableElevation
      disableRipple
      variant="outlined"
    />
  );
});

export const PrimaryContainedButton = React.forwardRef<
  HTMLButtonElement,
  ButtonProps
>((props, ref) => {
  return (
    <PrimaryContainedStyledButton
      ref={ref}
      {...props}
      disableElevation
      disableRipple
      variant="contained"
    />
  );
});

export const PrimaryOutlinedButton = React.forwardRef<
  HTMLButtonElement,
  ButtonProps
>((props, ref) => {
  return (
    <PrimaryOutlinedStyledButton
      ref={ref}
      variant="outlined"
      {...props}
      disableElevation
      disableRipple
    />
  );
});

export const PrimaryLoadingButton = React.forwardRef<
  HTMLButtonElement,
  LoadingButtonProps
>((props, ref) => {
  return (
    <PrimaryLoadingStyledButton
      ref={ref}
      {...props}
      disableElevation
      disableRipple
      variant="contained"
    />
  );
});

export const ButtonTypography = styled(Typography)(({ theme }) => ({
  fontWeight: '600',
  fontSize: 14,
}));

